import { type Car } from '@prisma/client'
import { isCarOlderThan6Years } from '#app/shared/lib/misc.tsx'
import { calculateDiscountedPrice, formatPrice } from '#app/shared/lib/price.ts'
import {
  PackOptimaBadge,
  PackOptimaWithModal,
} from '../PackOptimaComponents.tsx'

type Props = {
  car: Car
}

export default function CarPriceCardBottom({ car }: Props) {
  return (
    <div
      className={`
        flex h-5 items-center justify-between px-4

        sm:px-6
      `}
    >
      {!isCarOlderThan6Years(car) && (
        <p className="text-subtitle1-bold leading-[11px] text-neutral-500">
          <span className="text-base-bold leading-[11px] text-primary-500">
            {formatPrice(Math.round(car.minMonthlyPayment || 0))}
          </span>
          <span className="text-subtitle1-bold leading-[11px] text-neutral-500">
            /mes
          </span>
        </p>
      )}

      {isCarOlderThan6Years(car) ? (
        <PackOptimaBadge size="small" text="Garantía Óptima" />
      ) : (
        <PackOptimaWithModal
          size="small"
          discountAmount={
            (calculateDiscountedPrice(
              car.minFinancedAmount ?? 0,
              car.discount ?? 0,
            ) ?? 0) - car.price
          }
        />
      )}
    </div>
  )
}
